module.exports = __webpack_public_path__ + "static/media/8.bc590414.jpg";